
const getters = {
  getSavingById: (state, getters, rootState, rootGetters) => (id) => {
    console.log(state['moduleSaving'].savings)
    // return rootState.moduleSaving.savings.find(saving => saving.id === id)
  },
  // savings: state => state.savings,
}
export default getters